'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actions = [{
    type: 'SET_STYLES',
    propTypes: {
        styles: _proptypes2.default.object.isRequired
    }
}, {
    type: 'SET_STYLE_NUMBER',
    propTypes: {
        name: _proptypes2.default.string.isRequired,
        value: _proptypes2.default.number.isRequired
    }
}, {
    type: 'BULK_SET_STYLE_NUMBER',
    propTypes: {
        values: _proptypes2.default.arrayOf(_proptypes2.default.shape({
            name: _proptypes2.default.string.isRequired,
            value: _proptypes2.default.number.isRequired,
            updateUI: _proptypes2.default.bool
        }))
    }
}, {
    type: 'SET_STYLE_COLOR',
    propTypes: {
        name: _proptypes2.default.string.isRequired,
        value: _proptypes2.default.string.isRequired,
        updateUI: _proptypes2.default.bool
    }
}, {
    type: 'BULK_SET_STYLE_COLOR',
    propTypes: {
        values: _proptypes2.default.arrayOf(_proptypes2.default.shape({
            name: _proptypes2.default.string.isRequired,
            value: _proptypes2.default.string.isRequired
        })),
        updateUI: _proptypes2.default.bool
    }
}, {
    type: 'SET_STYLE_FONT',
    propTypes: {
        name: _proptypes2.default.string.isRequired,
        value: _proptypes2.default.string.isRequired,
        updateUI: _proptypes2.default.bool
    }
}, {
    type: 'BULK_SET_STYLE_FONT',
    propTypes: {
        values: _proptypes2.default.arrayOf(_proptypes2.default.shape({
            name: _proptypes2.default.string.isRequired,
            value: _proptypes2.default.string.isRequired
        })),
        updateUI: _proptypes2.default.bool
    }
}, {
    type: 'SET_STYLE_BOOLEAN',
    propTypes: {
        name: _proptypes2.default.string.isRequired,
        value: _proptypes2.default.bool.isRequired
    }
}, {
    type: 'SET_STYLE_DATA',
    propTypes: {
        name: _proptypes2.default.string.isRequired,
        value: _proptypes2.default.any.isRequired
    }
}, {
    type: 'RESET_COLORS_AND_FONTS'
}, {
    type: 'BULK_SET_STYLE_MIXED',
    propTypes: {
        numbers: _proptypes2.default.arrayOf(_proptypes2.default.shape({
            name: _proptypes2.default.string.isRequired,
            value: _proptypes2.default.number.isRequired
        })),
        booleans: _proptypes2.default.arrayOf(_proptypes2.default.shape({
            name: _proptypes2.default.string.isRequired,
            value: _proptypes2.default.bool.isRequired
        }))
    }
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions, 'STYLES_');
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions, 'STYLES_');


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/actions/StylesActions.js
// module id = 283
// module chunks = 0